import LottieLoaders from "../../../components/UI/LottieLoaders";

const LoadingDesignFiles = ({ files }) =>
  files.length > 0 ? (
    <LottieLoaders pageCount={files.length} />
  ) : (
    <LottieLoaders loader />
  );

export default LoadingDesignFiles;
